import { useEffect, useState } from "react";
import { getPageName } from "../../../../utils/general";
import Bot from "./Bot";


const CatalogBotsView = (props) => {
    let {
        bots = [],
        botHolderStyle = {
            marginBottom: "10px",
            width: "100%",
            borderRadius: "10px",
            boxShadow: "rgba(0, 0, 0, 0.2) 0px 0px 6px ",
        },
        subscribeToBot,
        createConversation,
        openBot,
        installingBotId,
        catalogSide
    } = props;

    const pathname = getPageName();
    const [emptyStateText, setEmptyStateText] = useState("bots");

    useEffect(() => {
        const messages = {
            Catalog_Featured: "No featured apps available.",
            Catalog_Categories: "No categories available.",
        };

        setEmptyStateText(catalogSide ? "No bots found." : messages[pathname]);
    }, [pathname]);


    const CatalogBotHolder = ({ className, style, children }) => (
        <div style={style} className={className}>
            {children}
        </div>
    );

    const newBotList = bots.filter((bot) => !bot.systemBot);
    return (
        <div className="col-lg-12 p-0">
            {newBotList && newBotList.length > 0 ? newBotList?.map((bot, index) => (
                <CatalogBotHolder key={index} style={botHolderStyle}>
                    <Bot
                        style={{ backgroundColor: "#fff", borderRadius: "10px" }}
                        key={bot.botId}
                        bot={bot}
                        open={openBot}
                        subscribeToBot={subscribeToBot}
                        createConversation={createConversation}
                        installingBotId={installingBotId}
                    />
                </CatalogBotHolder>
            ))
                :
                (<div className="flex justify-center items-center h-48 text-gray-500 text-size-16">{emptyStateText}</div>)
            }
        </div>
    );
};

export default CatalogBotsView;
